import { useState, useEffect } from "react";
import { Modal, Input } from "antd";
import { useAuth } from "../../../../store/AuthContext/AuthContext";
import { customRequest } from "../../../../common/request/customRequest";
import { DrawerPanelTitle, modalPanelStyles } from "../../../pages/common/Drawers/DrawerPanelTitle";

const FIXED_50_COLORS = [
  '#FF5733', '#33FF57', '#3357FF', '#FF33A1', '#FFBD33', '#33FFF5', '#8D33FF', '#C70039', '#900C3F', '#2ECC71',
  '#3498DB', '#9B59B6', '#1ABC9C', '#F1C40F', '#E67E22', '#E74C3C', '#16A085', '#27AE60', '#2980B9', '#8E44AD',
  '#D35400', '#C0392B', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77',
  '#EFC050', '#5B5EA6', '#9B2335', '#DFCFBE', '#55B4B0', '#E15D44', '#7FCDCD', '#BC243C', '#C34A47', '#91A3B0',
  '#1E272C', '#34495E', '#7F8C8D', '#2C3E50', '#130CB7', '#52057B', '#005F73', '#0A9396', '#94D2BD', '#EE9B00'
];

export default function EditVirtualGroupsModal(props: { groups: any, onChange: any }) {
  const { projectGroup } = useAuth();
  const [colorOptions, setColorOptions] = useState<{ color: string; name: string }[]>([]);
  const [visibleCount, setVisibleCount] = useState(10);

  useEffect(() => {
    if (!props.groups) return;
  
    const initialOptions = FIXED_50_COLORS.map(color => ({
      color,
      name: props.groups[color] || ''
    }));
  
    // 1. Contamos cuántos colores ya tienen nombre asignado
    const filledCountFromProps = initialOptions.filter(c => c.name.trim() !== "").length;
    
    // 2. Calculamos el múltiplo de 10 inmediatamente superior
    let nextMultipleOfTen = Math.ceil(filledCountFromProps / 10) * 10;
  
    // 3. ¡SOLUCIÓN!: Si coincide exactamente con la cantidad de llenos (o es 0), 
    // le sumamos 10 para asegurar que siempre haya un bloque extra vacío para escribir.
    if (nextMultipleOfTen === filledCountFromProps || nextMultipleOfTen === 0) {
      nextMultipleOfTen += 10;
    }
  
    // 4. Nos aseguramos de no pasarnos del límite de 50
    const finalVisibleCount = Math.min(50, nextMultipleOfTen);
    
    setColorOptions(initialOptions);
    setVisibleCount(finalVisibleCount);
  }, [props.groups]);

  // MANEJADOR CORREGIDO
  const handleLabelChange = (index: number, newName: string) => {
    const updatedColors = [...colorOptions];
    updatedColors[index].name = newName;
    setColorOptions(updatedColors);

    // Si el usuario escribe algo en el último input visible actual (o falta solo 1 para llegar al final)
    // Y todavía no estamos mostrando los 50 colores, revelamos los siguientes 10.
    if (newName.trim() !== "" && index >= visibleCount - 2 && visibleCount < 50) {
      setVisibleCount(prev => prev + 10);
    }
  };

  const handleSave = async () => {
    const namesObject = colorOptions.reduce((acc: any, curr) => {
      if (curr.name && curr.name.trim() !== "") {
        acc[curr.color] = curr.name;
      }
      return acc;
    }, {});

    const data = {      
      project: projectGroup.project,
      names: namesObject, 
    };  
        
    await customRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/virtual`, { 
      method: 'POST', 
      data: data 
    });      
    
    props.onChange();
  };

  return (
    <Modal 
      open={true} 
      onOk={handleSave} 
      onCancel={props.onChange}        
      {...modalPanelStyles}
      title={<DrawerPanelTitle title="Editar regiones" isProject={true} />}
      destroyOnClose
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div>
          <br/>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', maxHeight: '400px', overflowY: 'auto', paddingRight: '4px' }}>
            {colorOptions.slice(0, visibleCount).map((c, index) => (
              <div 
                key={c.color} 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  padding: '4px 8px',
                  borderRadius: '6px',
                  backgroundColor: 'transparent',
                  border: '1px solid transparent',
                  transition: 'all 0.2s'
                }} 
              >
                <div 
                  style={{ 
                    width: 16, 
                    height: 16, 
                    borderRadius: '50%', 
                    backgroundColor: c.color, 
                    marginRight: '12px',
                    border: '1px solid rgba(0,0,0,0.1)' 
                  }} 
                />
                <Input 
                  placeholder={`Nombre del grupo ${index + 1}...`}
                  value={c.name}
                  onChange={(e) => handleLabelChange(index, e.target.value)}
                  bordered={false} 
                  style={{ padding: '0px', fontSize: '14px', cursor: 'text' }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
}
